const StorageType = {
  AuthInfo: 'AUTH_INFO',
};

export const setAuth = info => {
  try {
    if (info) {
      localStorage.setItem(StorageType.AuthInfo, JSON.stringify(info));
    } else {
      localStorage.removeItem(StorageType.AuthInfo);
    }
  } catch (err) {
    console.log('setAuth', err);
  }
};

export const getAuth = () => {
  try {
    const data = localStorage.getItem(StorageType.AuthInfo);
    if (data) {
      try {
        return JSON.parse(data);
      } catch (err) {
        setAuth();
      }
    }
  } catch (err) {
    console.log('getAuth', err);
  }
};
